<template>
  <div>
    <v-autocomplete
      class="my-2"
      hide-details
      label="Portal User"
      :placeholder="loading == true ? 'loading...' : 'Start typing...'"
      @input="onUserSelected"
      :items="portalUsersNames"
      :rules="[rules.required]"
      :loading="loading"
      v-model="selectedUser"
      clearable
    ></v-autocomplete>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(val) {
        if (val && this.portalUsers.length === 0) {
          this.loadPortalUsers();
        }
        if (!val) {
          this.reset();
        }
      },
    },
  },
  data: () => ({
    loading: false,
    portalUsers: [],
    portalUsersNames: [],
    selectedUser: null,
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),
  methods: {
    async loadPortalUsers() {
      this.loading = true;
      try {
        const response = await this.$http.get(`/odata/users`);
        this.portalUsers = response.value;
        this.portalUsersNames = response.value.map((u) => u.userName);
      } catch (error) {
        console.error("Error loading portal users:", error);
      } finally {
        this.loading = false;
      }
    },
    onUserSelected(val) {
      this.$emit("selectedUser", val)
      this.$emit("portalUsers", this.portalUsers)
    },
    reset() {
      this.selectedUser = null;
    },
  },
};
</script>
